<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in">
          <div class="emd-alert _color_success hideFeedback" ref="feedback">
            <p>{{$t('edit.review.success_message')}}</p>
          </div>
          <div class="emd-flex">

            <div class="emd-flex-item emd-chunk _basis_12 _basis_6_md">
              <div v-if="issues.isLoading && issues.success" class="emd-box _state_loading"></div>
              <p v-else-if="!issues.isLoading && !issues.success" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
              <div v-else class="emd-box _stretch">
                <div class="emd-box__header">
                  {{$t('edit.review.app_review')}}
                </div>
                <div class="emd-box__content">
                  <div class="emd-chunk" v-for="(group, index) in issues.groups" :key="index">
                    <div class="emd-accordion _size_small _border">
                      <input class="emd-accordion__input" :id="`tab-${index}`" type="checkbox" :checked="!group.is_valid" name="tabs">
                      <label class="emd-accordion__label" :for="`tab-${index}`">
                        <span :class="['emd-status-tag', group.is_valid ? '_color_success':'_color_danger']">
                          <emd-circle/>
                        </span>
                          {{group.title}}
                      </label>
                      <div class="emd-accordion__content">
                        <div class="emd-section _separator">
                          <ul>
                            <li v-for="(item, key) in group.items" :key="key">
                              {{item.message}}
                              <span :class="['emd-status-tag', 'emd-text', group.is_valid ? '_color_success':'_color_danger', '_size_tiny']">
                                <emd-circle/>
                                {{group.is_valid ? $t('home.app.states.approved'): $t('home.app.states.reproved')}}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="emd-flex-item emd-chunk _basis_12 _basis_6_md">
              <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
              <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
              <div v-else class="emd-box _stretch">
                <div class="emd-box__header emd-flex _justify_space-between">
                  <div class="emd-flex-item">
                    {{$t('edit.review.history')}}
                  </div>
                  <div class="emd-flex-item">
                    <a :href="appUrl" class="emd-btn _color_primary _type_link">{{$t('edit.review.view_the_app')}}</a>
                  </div>
                </div>
                <div class="emd-box__content">
                  <div class="emd-timeline" v-if="reviews.length > 0">
                    <div class="emd-timeline__item" v-for="(review, index) in reviews" :key="index">
                      <div class="emd-timeline__icon" style="left: 5px;">
                        <span :class="['emd-status-tag', tagStatus(review.status)]">
                          <emd-circle/>
                        </span>
                      </div>
                      <div class="emd-timeline__content">
                        <label class="emd-text _style_label _size_tiny">{{ translatedStatus(review.status) }} - {{review.review_date || review.create_date | BRDate}}</label>
                        <p v-if="review.status === 'Reproved'">{{review.reproval_reason}}</p>
                        <p v-else>{{review.message}}</p>
                      </div>
                    </div>
                  </div>
                  <p v-else>{{$t('edit.review.none')}}</p>
                  <div class="emd-flex _justify_flex-end">
                    <div class="emd-flex-item">
                      <button class="emd-btn _color_secondary" type="button"  @click="openReviewModal = true">{{$t('edit.review.cta')}}</button>
                    </div>
                    <div class="emd-flex-item" v-if="isRoot">
                      <button class="emd-btn _color_secondary" type="button"  @click="openApproveModal = true">{{$t('edit.review.approve')}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        </div>

      </div>
      <modal :open="openReviewModal" :loading="false">
        <template slot="header">
          <h1 class="emd-text _size_page">{{ $t("breadcrumb.edit.review") }}</h1>
        </template>
        <template slot="content">
          <div class="emd-section _separator">
            <error-list :items="errors"></error-list>
            <form action="javascript:void(0)" @submit.prevent="submitToReview" novalidate="true" ref="reviewForm">
              <fieldset>
                <div class="emd-form-group">
                  <label class="emd-label u-required" for="password">{{$t('edit.review.message')}}:</label>
                  <textarea name="message" class="emd-input" id="message" v-model="body.message" required minlength="10"></textarea>
                </div>
              </fieldset>
              <fieldset>
                <div class="emd-flex">
                  <div class="emd-flex-item _shrink">
                    <button class="emd-btn _color_secondary" type="submit">{{$t('delete.confirm')}}</button>
                  </div>
                  <div class="emd-flex-item _shrink">
                    <button class="emd-btn _color_primary _type_text" type="button" @click="closeModals">{{$t('delete.cancel')}}</button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </template>
      </modal>
      <modal :open="openApproveModal" :loading="false">
        <template slot="header">
          <h1 class="emd-text _size_page">{{ $t("breadcrumb.edit.review") }}</h1>
        </template>
        <template slot="content">
          <div class="emd-section _separator">
          <error-list :items="errors"></error-list>
            <form action="javascript:void(0)" @submit.prevent="reviewApp" novalidate="true" ref="avaliateForm">
              <fieldset>
                <div class="emd-form-group">
                  <label class="emd-label u-required" for="password">{{$t('edit.review.status_label')}}:</label>
                  <div class="emd-select" id="status">
                    <select name="status" v-model="reviewBody.status" required>
                      <option value="Approved">{{$t('edit.review.status.Approved')}}</option>
                      <option value="Reproved">{{$t('edit.review.status.Reproved')}}</option>
                      <option value="ApprovedAsFutureApp">{{$t('edit.review.status.ApprovedAsFutureApp')}}</option>
                      <option value="PendingReview">{{$t('edit.review.status.PendingReview')}}</option>
                    </select>
                    <div class="emd-select__arrow"></div>
                  </div>
                </div>
                <div class="emd-form-group" v-show="reviewBody.status === 'Reproved'">
                  <label class="emd-label" for="message">{{$t('edit.review.message')}}:</label>
                  <textarea name="message" class="emd-input" id="message" v-model="reviewBody.reproval_reason"></textarea>
                </div>
              </fieldset>
              <fieldset>
                <div class="emd-flex">
                  <div class="emd-flex-item _shrink">
                    <button class="emd-btn _color_secondary" type="submit">{{$t('delete.confirm')}}</button>
                  </div>
                  <div class="emd-flex-item _shrink">
                    <button class="emd-btn _color_primary _type_text" type="button" @click="closeModals">{{$t('delete.cancel')}}</button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </template>
      </modal>
  </div>
</template>
<script>
import Modal from '@/components/project/Modal.vue'
import ErrorList from '@/components/project/ErrorList.vue'
import EmdCircle from '@/components/emerald/EmdCircle.vue'
import form from '@/plugins/form.js'

export default {
  name: 'ApplicationReview',
  components: {
    Modal,
    ErrorList,
    EmdCircle
  },
  data () {
    return {
      errors: [],
      issues: {
        isLoading: true,
        success: true,
        groups: []
      },
      openReviewModal: false,
      openApproveModal: false,
      body: {
        message: ''
      },
      reviewBody: {
        status: 'Approved',
        reproval_reason: undefined
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    publicAppKey () {
      return this.$route.params.publicAppKey
    },
    reviews () {
      return this.$store.state.application.detail.reviews || []
    },
    isRoot () {
      return this.$store.state.user.profile.user.is_root || this.$store.state.user.profile.user.is_employee
    },
    appUrl () {
      return `${process.env.VUE_APP_STORE_URL}/apps/dev/${this.publicAppKey}`
    }
  },
  filters: {
    BRDate: function (value) {
      const dateObj = new Date(value)
      return `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
    }
  },
  methods: {
    tagStatus (status) {
      let className
      switch (status) {
        case 'Approved':
          className = ' _color_success'
          break
        case 'PendingReview':
          className = '_color_info'
          break
        case 'Reproved':
          className = '_color_danger'
          break
        default:
          className = '_color_info'
      }
      return className
    },
    translatedStatus: function (value) {
      let statusName
      switch (value) {
        case 'Approved':
          statusName = this.$i18n.t('home.app.states.approved')
          break
        case 'PendingReview':
          statusName = this.$i18n.t('home.app.states.pendingReview')
          break
        case 'Reproved':
          statusName = this.$i18n.t('home.app.states.reproved')
          break
        case 'ApprovedAsFutureApp':
          statusName = this.$i18n.t('home.app.states.futureApp')
          break
        default:
          statusName = this.$i18n.t('home.app.states.review')
      }
      return statusName
    },
    closeModals () {
      this.openReviewModal = false
      this.openApproveModal = false
      this.errors = []
    },
    displayFeedback () {
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    submitToReview (e) {
      const elements = Object.assign([], e.target.elements)
      const invalidElements = elements.filter(e => e.validity.valid === false)
      const body = Object.assign({}, this.body)
      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('SUBMIT_REVIEW', body)
          .then((response) => {
            this.handleSuccessSubmit(response, submitButton)
            this.openReviewModal = false
          })
          .catch((response) => this.handleErrorSubmit(response, submitButton))
      } else {
        form.addInputError(invalidElements[0])
      }
    },
    reviewApp (e) {
      const elements = Object.assign([], e.target.elements)
      const invalidElements = elements.filter(e => e.validity.valid === false)
      const body = Object.assign({}, this.reviewBody)

      if (body.status !== 'Reproved') {
        body.reproval_reason = undefined
      }

      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('AVALIATE_APP', body)
          .then((response) => {
            this.handleSuccessSubmit(response, submitButton)
            this.openApproveModal = false
            return true
          })
          .catch((response) => this.handleErrorSubmit(response, submitButton))
      } else {
        form.addInputError(invalidElements[0])
      }
    },
    handleSuccessSubmit (response, submitButton) {
      window.scrollTo(0, 0)
      this.errors = []
      submitButton.classList.remove('_state_loading')
      this.displayFeedback()
    },
    handleErrorSubmit (response, submitButton) {
      this.errors = []
      if (response.status === 401) {
        this.errors.push({ message: this.$t('delete.401') })
      } else if (response.status === 400) {
        this.errors = response.body.errors
      } else if (response.status === 404) {
        this.errors.push({ message: this.$t('delete.404') })
      } else {
        this.errors.push({ message: this.$t('delete.500') })
      }
      submitButton.classList.remove('_state_loading')
    }
  },
  created () {
    this.$store.dispatch('GET_REVIEW_ISSUES', this.publicAppKey)
      .then(issues => {
        this.issues.isLoading = false
        this.issues.success = true
        this.issues.groups = issues.groups
      })
      .catch(e => {
        this.issues.isLoading = false
        this.issues.success = false
      })
  }
}
</script>
<style scoped>
.emd-box._state_loading {
  height: 302px;
  background-repeat: no-repeat;
  background-image:
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4);
  background-size:
    15% 25px,
    8% 10px,
    25% 15px,
    48% 15px,
    8% 10px,
    25% 15px,
    48% 15px,
    8% 10px,
    25% 15px,
    48% 15px;
  background-position:
    1.59% 5.5%,
    1.59% 26.5%,
    1.8% 32.99%,
    2.55% 41%,
    1.5% 48.5%,
    1.8% 56%,
    2.59% 64%,
    1.5% 71%,
    1.8% 78.5%,
    2.59% 86%;
  opacity: 1;
  animation: opacity 1s infinite ease-in;
}
</style>
